import { useEffect, useRef } from 'react';

const useSyncAnimations = (isLeftActive: boolean, isRightActive: boolean) => {
	const leftRefState = useRef<HTMLImageElement>(null);
	const rightRefState = useRef<HTMLImageElement>(null);
	const timeline = useRef<AnimationTimeline>();

	useEffect(() => {
		if (isLeftActive && isRightActive) {
			timeline.current = document.timeline;

			leftRefState.current?.getAnimations().forEach((anim) => {
				(anim as any).timeline = timeline.current;
				if (timeline?.current?.currentTime) {
					anim.startTime = timeline.current.currentTime;
				}
			});

			rightRefState.current?.getAnimations().forEach((anim) => {
				(anim as any).timeline = timeline.current;
				if (timeline?.current?.currentTime) {
					anim.startTime = timeline.current.currentTime;
				}
			});
		}
	}, [isLeftActive, isRightActive]);

	return { leftRefState, rightRefState };
};

export { useSyncAnimations };
